module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"}
// module id = 1
// module chunks = 0